import { render, staticRenderFns } from "./article_det.vue?vue&type=template&id=a222db2e&lang=pug&"
import script from "./article_det.vue?vue&type=script&lang=js&"
export * from "./article_det.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports